"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHelpAndTerms = void 0;

var _runtimeConfigHelper = require("./runtime-config-helper");

var _get = _interopRequireDefault(require("lodash/get"));

var getUrl = function getUrl(name) {
  var runtimeConfig = (0, _runtimeConfigHelper.getRuntimeConfig)();

  if (!runtimeConfig._help && !runtimeConfig._terms) {
    return null;
  }

  switch (name) {
    case 'domainexpiry':
      return (0, _get["default"])(runtimeConfig._help, 'domainexpiry');

    case 'freeSSL':
      return (0, _get["default"])(runtimeConfig._help, 'freessl');

    case 'how-do-i-link-a-domain':
      return (0, _get["default"])(runtimeConfig._help, 'howtolinkadomain');

    case 'learnMoreAlexa':
      return (0, _get["default"])(runtimeConfig._help, 'learnmorealexa');

    case 'learnMoreVat':
      return (0, _get["default"])(runtimeConfig._help, 'learnmorevat');

    case 'paypal-account-update-faq':
      return (0, _get["default"])(runtimeConfig._help, 'paypal-update');

    case 'regularRates':
      return (0, _get["default"])(runtimeConfig._help, 'regularrates');

    case 'whois-information-domain-privacy':
      return (0, _get["default"])(runtimeConfig._help, 'whois');

    case 'autoRenewal':
      return (0, _get["default"])(runtimeConfig._terms, 'autorenewal');

    case 'cancellation':
      return (0, _get["default"])(runtimeConfig._terms, 'cancellation');

    case 'moneyBack':
      return (0, _get["default"])(runtimeConfig._terms, 'moneyback');

    case 'privacyPolicy':
      return (0, _get["default"])(runtimeConfig._terms, 'privacypolicy');

    case 'terms':
      return (0, _get["default"])(runtimeConfig._terms, 'terms');

    default:
      if (process.env.NODE_ENV !== 'production') {
        console.warn("Couldn't find '".concat(name, "' in the help/terms list"));
      }

      return '';
  }
};

var getHelpAndTerms = function getHelpAndTerms(name) {
  return getUrl(name);
};

exports.getHelpAndTerms = getHelpAndTerms;